
import MainLayout from "@/components/layout/MainLayout";

const AvisoIA = () => {
  return (
    <MainLayout showSidebar={false}>
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-8">Aviso sobre IA</h1>
        
        <div className="prose max-w-none">
          <p className="mb-4">Última atualização: 14 de Maio de 2025</p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Natureza do Serviço</h2>
          <p className="mb-4">
            O Vive Calme utiliza tecnologia de inteligência artificial (IA) para gerar respostas e 
            interagir com os usuários. É importante que você compreenda as seguintes informações sobre 
            a natureza e limitações deste serviço baseado em IA.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Limitações da IA</h2>
          <ul className="list-disc pl-5 mb-4">
            <li className="mb-2">
              As respostas geradas pela IA são baseadas em padrões aprendidos de grandes conjuntos de 
              dados e não representam conhecimento genuíno ou compreensão humana.
            </li>
            <li className="mb-2">
              A IA pode cometer erros, fornecer informações imprecisas ou responder de maneira inadequada 
              em determinadas situações.
            </li>
            <li className="mb-2">
              O Vive Calme não é uma ferramenta de diagnóstico médico ou psicológico e não deve ser 
              utilizado como substituto para aconselhamento profissional.
            </li>
            <li className="mb-2">
              Em casos de emergência ou crises de saúde mental, procure ajuda profissional imediatamente, 
              não confie apenas no Vive Calme.
            </li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Uso Responsável</h2>
          <p className="mb-4">
            Encorajamos o uso responsável do Vive Calme como uma ferramenta complementar para reflexão 
            e bem-estar. Sempre avalie criticamente as respostas fornecidas e utilize seu próprio 
            julgamento ao considerar as sugestões ou informações recebidas.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Supervisão Humana</h2>
          <p className="mb-4">
            Utilizamos uma combinação de revisão automatizada e supervisão humana para monitorar e 
            melhorar nossos sistemas de IA. Em alguns casos, profissionais humanos podem revisar 
            amostras de conversas para fins de treinamento e aprimoramento do sistema, sempre respeitando 
            nossas políticas de privacidade.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Feedback</h2>
          <p className="mb-4">
            Valorizamos seu feedback sobre a experiência com nossa IA. Se você encontrar respostas 
            problemáticas, imprecisas ou inadequadas, pedimos que nos informe através da funcionalidade 
            de feedback disponível no aplicativo.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Desenvolvimento Contínuo</h2>
          <p className="mb-4">
            Estamos comprometidos com a melhoria contínua de nossos sistemas de IA para torná-los 
            mais úteis, precisos e responsáveis. Atualizamos regularmente nossos modelos e sistemas 
            com base em pesquisas recentes e feedback dos usuários.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">Contato</h2>
          <p className="mb-4">
            Para questões específicas relacionadas ao uso de IA em nosso serviço, entre em contato 
            através do email: ia@vivecalme.com
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default AvisoIA;
